import { createSlice, PayloadAction, noopReducer } from 'ngrx-slice';
import { createSliceEntityAdapter } from 'ngrx-slice/entity';
import { filter } from 'rxjs';

import {
  PageableObject,
  ProductSortimentCreateResponse,
  ProductSortimentPageResponse,
  ProductTransferCreateRequest,
  SortObject,
} from '@app/api/marketplace/models';
import { Unit } from '@products/interfaces/models';
import { PageResponse } from '@shared/interfaces/page-response.interface';

import { PageRequest } from './../../shared/interfaces/page-request.interface';

export interface ProductSortimentPageRequest extends PageRequest {
  drinkTypeList?: Array<string>;
  brand?: string;
  name?: string;
  amount?: number;
  unit?: Unit;
  ean?: string;
  priced?: boolean;
  hasCollectionPackaging?: boolean;
}

export const initialDatasState = {
  totalPages: 0,
  totalElements: 0,
  size: 0,
  content: [],
  number: 0,
  sort: {} as SortObject,
  pageable: {} as PageableObject,
  first: true,
  last: true,
  numberOfElements: 0,
  empty: true,
};

export interface State {
  // productSortiment - get
  packagingUnitId: string;
  createResponse: ProductSortimentCreateResponse;
  productSortimentFilter: ProductSortimentPageRequest;
  productSortimentStoredFilter: ProductSortimentPageRequest;
  productSortimentLoadError: boolean;
  productSortimentLoading: boolean;
  productSortiment: PageResponse<ProductSortimentPageResponse>;
  totalProductSortiment: number;
}

export const initialState: State = {
  // productSortiment - get
  packagingUnitId: '',
  createResponse: {
    sortimentId: '',
    packagingUnitId: '',
    merchantId: '',
  },
  productSortimentFilter: {
    page: 0,
    size: 100,
  },
  productSortimentStoredFilter: {},
  productSortimentLoading: false,
  productSortimentLoadError: false,
  productSortiment: initialDatasState,
  totalProductSortiment: 0,
};

export const {
  actions: ProductSortimentActions,
  selectors,
  ...ProductSortimentFeature
} = createSlice({
  name: 'productSortiment',
  initialState,
  reducers: {
    loadProductSortiment: {
      trigger: (state) => {
        state.productSortiment = initialDatasState;
        state.productSortimentLoading = true;
      },
      success: (
        state,
        action: PayloadAction<{
          response: PageResponse<ProductSortimentPageResponse>;
        }>
      ) => {
        state.productSortiment = action.response;
        state.totalProductSortiment = action?.response.totalElements ?? 0;
        state.productSortimentLoading = false;
        state.productSortimentLoadError = false;
      },
      failure: (state) => ({
        ...state,
        productSortimentLoading: false,
        productSortimentLoadError: true,
      }),
    },
    updateFilter: {
      trigger: (
        state,
        action: PayloadAction<{ filter: ProductSortimentPageRequest }>
      ) => {
        state.productSortimentFilter = {
          ...state.productSortimentFilter,
          ...action.filter,
        };
        if (
          !action.filter?.hasOwnProperty('page') &&
          !action.filter?.hasOwnProperty('sort')
        ) {
          state.productSortimentFilter = {
            ...state.productSortimentFilter,
            page: 0,
          };
        }
      },
      success: noopReducer(),
    },
    updateStoredFilter: {
      trigger: (
        state,
        action: PayloadAction<{ filter: ProductSortimentPageRequest }>
      ) => {
        state.productSortimentStoredFilter = action.filter;
      },
      success: noopReducer(),
    },
    addProductToSortiment: {
      trigger: (state, action: PayloadAction<{ packagingUnitId: string }>) => {
        state.packagingUnitId = action.packagingUnitId;
      },
      success: (
        state,
        action: PayloadAction<ProductSortimentCreateResponse>
      ) => {
        state.createResponse = action;
      },
      failure: (state) => ({
        ...state,
      }),
    },
    deleteProductSortiment: {
      trigger: (
        state,
        action: PayloadAction<{ productSortimentId: string }>
      ) => {
        state.productSortimentFilter = {
          ...state.productSortimentStoredFilter,
          page: 0,
          size: 100,
        };
      },
      success: noopReducer(),
    },
    createProductTransfer: {
      trigger: (
        state,
        action: PayloadAction<{ request: ProductTransferCreateRequest }>
      ) => {},
      success: noopReducer(),
    },
    reset: (_) => initialState,
  },
});

export const ProductSortimentSelectors = {
  ...selectors,
};
